import {FC} from 'react';

import {Box, Typography} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import {useAppSelector} from 'hooks';
import {getHMMHour} from 'utils';

import {IExpressDeliveryOptionProps} from './types';

export const DeliveryExpressOption: FC<IExpressDeliveryOptionProps> = ({
  Icon,
  name,
  eligibleItems,
  totalItems,
  isSelected,
  onClick,
  isDisabled,
  isOutOfOrderingTime
}) => {
  const {t} = useTranslation();
  const {basket} = useAppSelector((state) => state.basket);
  return (
    <Box
      onClick={onClick}
      paddingX={1}
      width={116}
      boxSizing="border-box"
      paddingY={2}
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      flexDirection="column"
      gap={0.25}
      borderRadius={3}
      bgcolor={isSelected ? 'common.mds_global_color_white' : 'none'}
      position="relative"
      data-test-id={`express_delivery_option`}
    >
      <Box
        width={'fit-content'}
        bgcolor={isDisabled ? '#C7C7C7' : '#FD1E1B'}
        paddingX={1.25}
        paddingY={0}
        borderRadius={1}
        position="absolute"
        top={0}
        right={0}
      >
        <Typography color="common.mds_global_color_white" fontSize={10} lineHeight={1.75} fontWeight={700}>
          {isDisabled ? t('label.close') : t('unifiedBasket.label.express')}
        </Typography>
      </Box>
      <Icon />
      <Typography fontWeight={600} fontSize={12}>
        {name}
      </Typography>
      <Typography fontSize={11}>
        {isDisabled && isOutOfOrderingTime ? (
          <Trans
            i18nKey={'unifiedBasket.message.expressOpenTime'}
            values={{
              from: getHMMHour(basket?.expressStoreInfo?.[0]?.expressDeliveryTimeFrame?.from || 6),
              to: getHMMHour(basket?.expressStoreInfo?.[0]?.expressDeliveryTimeFrame?.to || 16)
            }}
          />
        ) : (
          <Trans i18nKey={'unifiedBasket.message.itemsAmount'} values={{eligibleItems, totalItems}} />
        )}
      </Typography>
    </Box>
  );
};
